<template>

  <div>

    <div class="section-header"><label-name labelKey="SITE-APOPOINT-HEADING-OPENING_HOURS"></label-name></div>

    <loading-indicator :loading="isLoading" style="height: 145px;"></loading-indicator>

    <template v-if="!isLoading">

      <template v-if="dates.length == 0">

        <alert type="info" style="background:#F5F5F5; color: #555;" class="infoSpecialOUT">
          Für diese Apotheke liegen keine Öffnungszeiten aus der externen Schnittstelle vor.
        </alert>

      </template>

      <div v-else class="section">

        <div style="display: flex;" v-for="(item, key) in dates" :key="item.id">

          <!--
          <div style="min-width: 50px;">{{ item.dayInWeek }}:</div> {{ item.openTime.match(/\d\d:\d\d/)[0] }} - {{ item.closeTime.match(/\d\d:\d\d/)[0] }}
          -->

          <!-- <div style="min-width: 100px">{{ item.date }}</div> -->
          <div style="min-width: 40px;">{{ item.day }}</div> {{ item.time }} Uhr

        </div>
      </div>

      <template v-if="jsonData.length">
        <button class="button is-outline is-small" @click="showJSONData=!showJSONData">
          <span class="icon is-small"><i class="icon-ak-preview"></i></span>alle Daten {{ showJSONData ? 'ausblenden' : 'einblenden' }}
        </button>

        <div class="section" v-show="showJSONData" style="max-height: 640px; overflow-y: scroll;">
          <div><pre>{{ jsonData }}</pre></div>
        </div>
      </template>

    </template>


  </div>

</template>



<script>
export default {

	name: 'pharmacyOpeningHours',

  props: {
    siteId: {
      type: Number,
      required: true,
      default: null
    }
  },


	data() {

		return {
      jsonData: null,
      showJSONData: false,
      dates: [],
      isLoading: true,
    }

  },

  created() {
    this.fetchOpeningHours();
  },

	mounted() {

	},

  computed: {

      weekDays() {
        return ["So","Mo","Di","Mi","Do","Fr","Sa"];
      }
  },

  methods: {

    fetchOpeningHours() {


      // this.axios.get(`${this.$config.api}site/${this.siteId}/nightDutyDates?full=1`).then((res) => {
      this.axios.get('https://datenbank.apothekenkatalog.at/herba/public/api/site/'+this.siteId+'/nightDutyDates?full=1').then((res) => {
        // filter all data so that only those from the last 7 days are included
        let currentDate = new Date(new Date().setDate(new Date().getDate()-7)).toISOString();
        this.jsonData = res.data.filter((item) => item.date > currentDate);

        let weekDaysHelper = [];

        let dates = res.data.filter((item) => item.details && item.details[0].typ == "O");
        let newDatesArr = [];

        dates.forEach((item) => {

          let d = new Date(item.date);
          let weekDay = this.weekDays[d.getDay()];

          if(!weekDaysHelper.includes(weekDay)) {

            weekDaysHelper.push(weekDay);

            this.dates.push({
              date: this.formatDate2(item.date, false),
              day: weekDay,
              time: item.details[0].zeit
            })

          }
        });
        var self = this;
        // sort array by weekDay
        this.dates.sort(function sortByDay(a, b) {
          let day1 = a.day;
          let day2 = b.day;
          return self.weekDays.indexOf(day1) < self.weekDays.indexOf(day2) ? -1 : 1;
        });

        this.isLoading = false;

      })
    }

  }

}

</script>

<style lang="scss" scoped>
.section {
  margin: 0 0 32px 0;
  padding: 24px 16px;
  width: 100%;
  max-width: 1024px;
  background-color: #F5F5F5;
  border-radius: 4px;
}

.section-header {
  padding: 0 0 6px 0;
  text-transform: uppercase;

  .label {
    color: #999;
  }
}
</style>
